import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.background_white};
  height: 2rem;
  width: 7.3rem;

  p {
    display: flex;
    align-items: center;
    margin: 0;
    padding-left: 0.2rem;
    color: ${({ theme }) => theme.colors.text} !important;
    font-size: 1.3rem;
    height: 1.6rem;
  }
  input {
    width: 5.3rem;
    background-color: transparent;
    border: none;
    text-align: end;
    border-radius: 0.75rem;
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.text} !important;
    outline: none;
    ::placeholder {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`;
